export class ActivityQueryParameters {
  activityTypes?: string[];
  employeeId: string | string[];
  startDate?: Date;
  overdueActivities?: boolean;
  showAllServiceAppointments?: boolean;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
